/* @flow */

class UserAgent {
  get agent(): string {
    if (typeof navigator !== 'undefined') {
      return navigator.userAgent || navigator.vendor;
    } else if (typeof window !== 'undefined') {
      return window.opera;
    } else {
      return '';
    }
  }

  get ios(): boolean {
    return /iPad|iPhone|iPod/.test(this.agent);
  }

  get android(): boolean {
    return /android/i.test(this.agent);
  }
}

export default new UserAgent();



// WEBPACK FOOTER //
// ./src/utilities/UserAgent.js